import { request } from '@/_service/http-client';
import { Brand, BrandParams, BrandsResponse } from '../model/types';

export const brandApi = {
  getAll: async (params: BrandParams): Promise<BrandsResponse> => {
    const { data } = await request.get('/v2/mika/shippers', { params });
    return data;
  },
  getById: async (id?: string, params?: BrandParams): Promise<Brand> => {
    const { data } = await request.get(`/v1/shippers/${id}`, { params });
    return data;
  },
};
